import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {openAlert} from '../../slices/alert';
import {closeDialog} from '../../slices/dialog';
import {selectUid} from '../../slices/auth';
import {Collections} from '../../api/collections';
import {uploadSubmission} from '../../api/game';
import {fileRequestToExtensions} from '../../helpers/misc';
import Button from '../Common/Button';
import {selectUser} from '../../slices/profile';

export const GameSubmission = ({game}) => {
    const {register, handleSubmit, errors, setError, setValue} = useForm({});
    const [extensions, setExtensions] = useState("");
    const [loading, setLoading] = useState(false);
    const user = useSelector(selectUser);
    const uid = useSelector(selectUid);
    const name = user?.name;
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        setExtensions(fileRequestToExtensions(game.request));
    }, [game]);

    const onSubmit = form => {
        if (form.file.length !== 1) return;

        // check if file extension is supported
        const allowedExtensions = extensions.split(", ");

        const file = form.file[0];

        const isValidFile = allowedExtensions.map(ext => file.name.endsWith(ext)).includes(true);

        if (!isValidFile) {
            setError("file", "required");
            setValue("file", null);
            return;
        }

        // file extension is ok, upload the file

        setLoading(true);

        const sub = {
            studentId: uid,
            created: new Date(),
            gameId: game.id,
            rmId: game.rmId,
            companyId: game.companyId
        };

        const onComplete = () => {
            dispatch(openAlert({type: "success", message: t("alert_sub_sent")}));
            dispatch(closeDialog());
            setLoading(false);
        };

        const onError = () => {
            dispatch(openAlert({type: "error", message: t("alert_generic_error")}));
            dispatch(closeDialog());
            setLoading(false);
        };

        uploadSubmission(
            sub,
            file,
            `${game.companyId}/games/${game.id}/submissions/${name}_${file.name}`,
            `${Collections.GAMES}/${game.id}/${Collections.SUBMISSIONS}/${uid}`,
            onComplete,
            onError
        );
    }

    return (
        <div className="gameSubmission">
            <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={loading}>
                    <div className="element">
                        <div className="label">{t("student_submission_attachment")}</div>
                        <input type="file" name="file" accept={extensions} ref={register({required: true})}/>
                        <p>* {extensions}</p>
                        {errors.file && <span className="error">{t("student_submission_error")}</span>}
                    </div>
                    <Button type="submit" loading={loading}>{t("student_submission_submit")}</Button>
                </fieldset>
            </form>
        </div>
    )
}
